/* tslint:disable */
export var icon = "\n<svg width=\"10\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.25 6.982l-.018.518H8.978l-5.423 6.972.195-5.454.018-.518H1.022l5.423-6.972-.195 5.454z\" stroke=\"currentColor\"/></svg>\n";
//# sourceMappingURL=lightning-vertical.svg.js.map